import { useNavigate, useParams } from "react-router-dom";

import { apiFetchWithAuth } from "../../../../api";
import useLocalStorage from "../../../../hooks/useLocalStorage";
import useLocation from "../../../../hooks/useLocation";
import { ApiCompetition } from "../../../../types";
import EmailScreen from "./EmailScreen/EmailScreen";
import LoginScreen from "./LoginScreen/LoginScreen";
import RegisterScreen from "./RegisterScreen/RegisterScreen";

export const EntryEmailScreen = () => {
  const location = useLocation<{ isParent: boolean }>();

  const navigate = useNavigate();

  const isParent = location.state?.isParent;

  const onNext = ({
    email,
    emailExists,
  }: {
    email: string;
    emailExists: boolean;
  }) => {
    if (emailExists) {
      navigate("../login", {
        state: {
          email,
          isParent,
        },
      });
    } else {
      if (!isParent) {
        navigate("../age", { state: { email } });
      } else {
        navigate("../register", { state: { email, isParent } });
      }
    }
  };

  return <EmailScreen onNext={onNext} />;
};

export const EntryLoginScreen = () => {
  const location = useLocation<{ isParent: boolean; email: string }>();
  const params = useParams();

  const navigate = useNavigate();

  const isParent = location.state?.isParent;
  const [_, setIsParent] = useLocalStorage(
    `${params.competitionUUID}/isParent`,
    false
  );

  const onLogin = async () => {
    const competition = await apiFetchWithAuth<ApiCompetition>(
      `/competitions/${params.competitionUUID}`
    );
    if (
      competition.userEntry ||
      competition.childEntries.length ||
      competition.canJudge
    ) {
      navigate(`/${params.competitionUUID}`);
      return;
    }
    if (isParent) {
      navigate("../competitors");
      setIsParent(true);
    } else {
      navigate("../confirm", {
        state: { isParent, didJustRegister: false },
      });
    }
  };

  return <LoginScreen onLogin={onLogin} />;
};

export const EntryRegisterScreen = () => {
  const location = useLocation<{ isParent: boolean; email: string }>();
  const params = useParams();

  const navigate = useNavigate();

  const isParent = location.state?.isParent;

  const [_, setIsParent] = useLocalStorage(
    `${params.competitionUUID}/isParent`,
    false
  );

  const onRegister = () => {
    if (isParent) {
      navigate("../competitors");
      setIsParent(true);
    } else {
      navigate("../confirm", { state: { isParent, didJustRegister: true } });
      setIsParent(false);
    }
  };

  return <RegisterScreen isJudge={false} onRegister={onRegister} />;
};
